const excelDateNumber  = (excelDate) => {
    let date = new Date(Math.round(excelDate - (25567 + 1)) * 86400 * 1000);
    let convertedDate = date.toISOString().split('T')[0];
    return convertedDate;
};

export default excelDateNumber;
